import { render, staticRenderFns } from "./ByTags.vue?vue&type=template&id=44e9918f&"
import script from "./ByTags.vue?vue&type=script&lang=ts&"
export * from "./ByTags.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports